import { render } from "./LightboxTemplateHeader.vue?vue&type=template&id=3464fd99&scoped=true"
import script from "./LightboxTemplateHeader.vue?vue&type=script&lang=js"
export * from "./LightboxTemplateHeader.vue?vue&type=script&lang=js"

import "./LightboxTemplateHeader.vue?vue&type=style&index=0&id=3464fd99&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3464fd99"]])

export default __exports__